import { render } from "./AllCardsext.vue?vue&type=template&id=72c5bc9c&scoped=true"
import script from "./AllCardsext.vue?vue&type=script&lang=js"
export * from "./AllCardsext.vue?vue&type=script&lang=js"

import "./AllCardsext.vue?vue&type=style&index=0&id=72c5bc9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c5bc9c"]])

export default __exports__